export default __webpack_public_path__ + "static/product-unit-4-wallet-44643d89f1dcc19e931d6fe58e91a14c.png";